import React from 'react'

export default function NotFoundComponent() {
  return (
    <div>Not Found</div>
  )
}
